import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarMode, MatProgressBar } from '@angular/material/progress-bar';
import { ProgressService } from '@shared/progress/services';

@Component({
  standalone: true,
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  imports: [CommonModule, MatProgressBar]
})
export class ProgressBarComponent {
  @Input() mode: ProgressBarMode = "indeterminate";
  show: boolean = false;

  constructor(progressService: ProgressService, private cdr: ChangeDetectorRef) {
    progressService.startProgress.subscribe(() => {
      this.show = true;
      this.cdr.detectChanges();
    });
    progressService.completeProgress.subscribe(() => {
      this.show = false;
      this.cdr.detectChanges();
    });
  }
}
